import React, { useContext, useEffect, useState } from 'react';
import icons from '@bbkAdminUtils/icons';
import { cs } from '@bbkAdminUtils/css-utils';
import './plays.scss';

export const CollapsableFormContext = React.createContext<{
  currentViewId: number;
  setCurrentViewId: React.Dispatch<React.SetStateAction<number>>;
}>(undefined!);

export const CollapsableFormContextProvider: React.FC<
  React.PropsWithChildren
> = ({ children }) => {
  const [currentViewId, setCurrentViewId] = useState<number>(0);

  return (
    <CollapsableFormContext.Provider
      value={{
        currentViewId,
        setCurrentViewId,
      }}
    >
      {children}
    </CollapsableFormContext.Provider>
  );
};

type CollapsableFormArgs = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  id: number;
  collapseElement?: React.ReactNode;
};

export const CollapsableForm: React.FC<
  React.PropsWithChildren<CollapsableFormArgs>
> = ({ title, subtitle, children, collapseElement, id }) => {
  const [show, setShow] = useState<boolean>(true);

  const { currentViewId } = useContext(CollapsableFormContext);

  useEffect(() => {
    if (currentViewId === id || currentViewId === 0) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [currentViewId, id]);

  return (
    <div className="collapsable-form tw-flex tw-flex-col">
      <div className="tw-flex tw-items-center">
        <div className="tw-text-xl tw-font-semibold">{title}</div>
        <button
          className="tw-flex tw-flex-grow tw-items-center"
          onClick={() => setShow(!show)}
        >
          {subtitle && (
            <>
              <div className="v-line" />
              <div className="tw-flex-grow tw-text-left">{subtitle}</div>
            </>
          )}
          <div className="tw-flex-grow" />
          <div className={cs('chev-icon', { 'hide-icon': !show })}>
            <span>{icons.chevronDown}</span>
          </div>
        </button>
      </div>
      <div className="cf-content">{show ? children : collapseElement}</div>
    </div>
  );
};
